/*
 *
 * Returns true if the current <body> matches the given slug.
 * It checks in the following order:
 * 1. Whether the <body> has a CSS class equal to the slug.
 * 2. Whether the `data-page` attribute exists and contains the slug.
 * 3. Whether the `data-site-type` attribute exactly matches the slug.
 * This allows identifying both specific page contexts (via classes and data-page) and multisite contexts (via data-site-type).
 *
 */
var isPage = function (slug) {
    var body = document.body;
    return ((body === null || body === void 0 ? void 0 : body.classList.contains(slug)) ||
        ((body === null || body === void 0 ? void 0 : body.dataset.page) && body.dataset.page.includes(slug)) ||
        (body === null || body === void 0 ? void 0 : body.dataset.siteType) === slug ||
        false);
};
import { scrollEntryAnimation } from '../helpers/scroll-entry-animation';
import { HoldPageController } from './hold-page.controller';
export var UIController = {
    init: function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                _this.initEntryAnimateScroll();
                isPage('main-site') && HoldPageController.init();
                resolve();
            }
            catch (error) {
                reject(error);
            }
        });
    },
    initEntryAnimateScroll: function () {
        scrollEntryAnimation([
            { selector: '.animate-entry', threshold: 0.6, once: false },
            { selector: '.swiper-wrapper .team-member__card', threshold: 0.6, once: false },
            { selector: '.news-list .swiper-wrapper .swiper-slide', threshold: 0.6, once: false },
        ]);
    },
};
